import { Component, inject, model } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { IAccommodationOfferShort } from 'src/app/interfaces/interface';

@Component({
  selector: 'app-dialog-warning-confirm',
  imports: [MatDialogModule, MatButtonModule],
  templateUrl: './dialog-warning-confirm.component.html',
  styleUrl: './dialog-warning-confirm.component.scss',
})
export class DialogWarningConfirmComponent {
  readonly dialogRef = inject(MatDialogRef<DialogWarningConfirmComponent>);
  readonly currentOffer = inject<IAccommodationOfferShort>(MAT_DIALOG_DATA);
  readonly confirmedOfferId = model(this.currentOffer);

  onNoClick(): void {
    this.dialogRef.close();
  }
}
